import FilterTextInput from "../FilterTextInput";
import { motion as m } from "framer-motion";
import Paginator from "../Paginator";

const GuestUploadPreviewTable = ({
  title,
  searchable,
  data,
  meta,
  handlePageClick,
  searchTerm,
  handleSearch,
  handlePerPageChange,
  perPage,
}) => {
  return (
    <m.div
      className="flex flex-col border border-[#EFF0F2] w-full h-fit bg-white rounded-xl"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* Title */}
      {title && (
        <div className="flex w-full border-b border-[#EFF0F2] px-[24px] py-[16px] justify-between items-center">
          <h2>{title}</h2>
        </div>
      )}

      {/* Filters */}
      {searchable && (
        <div className="flex w-full border-b border-[#EFF0F2] px-[24px] py-[12px] justify-end">
          <FilterTextInput value={searchTerm} onChange={handleSearch} />
        </div>
      )}

      {/* Table data */}
      <div className="flex w-full h-full gap-[24px] no-scrollbar overflow-x-auto">
        {!data || data.length === 0 ? (
          <div className="flex w-full h-[290px] items-center border-[#EFF0F2] justify-center text-gray-500 text-[25px]">
            No guests found
          </div>
        ) : (
          <div className="w-full overflow-x-auto">
            <table className="w-full min-w-max table-auto">
              {/* Table Header */}
              <tr className="w-full bg-[#F7F8F9]">
                <th className="text-start px-[24px] py-[16px]">
                  Title/Salutation
                </th>
                <th className="text-start px-[24px] py-[16px]">Guest Name</th>
                <th className="text-start px-[24px] py-[16px]">Email</th>
                <th className="text-start px-[24px] py-[16px]">Contact</th>
                <th className="text-start px-[24px] py-[16px]">Group</th>
                <th className="text-start px-[24px] py-[16px]">Table</th>
                <th className="text-start px-[24px] py-[16px]">Tag</th>
                <th className="text-start px-[24px] py-[16px]">
                  Special Dietary
                </th>
              </tr>

              {/* Table Body */}
              {data &&
                data.map((item, index) => (
                  <tr
                    key={index}
                    className="w-full font-normal border-y border-[#EFF0F2] last:border-none"
                  >
                    <td className="px-[24px] py-[16px]">
                      {item.salutation ?? "-"}
                    </td>
                    <td className="px-[24px] py-[16px]">
                      {item.first_name && item.last_name
                        ? `${item.first_name} ${item.last_name}`
                        : "-"}
                    </td>
                    <td className="px-[24px] py-[16px]">{item.email ?? "-"}</td>
                    <td className="px-[24px] py-[16px]">
                      {item.contact ?? "-"}
                    </td>
                    <td className="px-[24px] py-[16px]">
                      {item.group_name ?? "-"}
                    </td>
                    <td className="px-[24px] py-[16px]">{item.table ?? "-"}</td>
                    <td className="px-[24px] py-[16px]">{item.tag ?? "-"}</td>
                    <td className="px-[24px] py-[16px]">
                      {item.special_dietary ?? "-"}
                    </td>
                  </tr>
                ))}
            </table>
          </div>
        )}
      </div>

      {/* Pagination */}
      {meta && (
        <Paginator
          meta={meta}
          handlePageClick={handlePageClick}
          perPage={perPage}
          handlePerPageChange={handlePerPageChange}
        />
      )}
    </m.div>
  );
};

export default GuestUploadPreviewTable;
